import { useState } from 'react';
import { getLocalWinningAuction } from '../../services/orderService';

const useGetLocalWinningAuction = () => {
  const [localAuction, setLocalAuction] = useState([]);
  const [localLoading, setLocalLoading] = useState(false);
  const [localError, setLocalError] = useState(null);

  const fetchLocalWinningAuctions = async () => {
    setLocalLoading(true);
    try {
      const data = await getLocalWinningAuction();
      setLocalAuction(data);
    } catch (err) {
      if (err.response) {
        setLocalError(`${err.response.data.message || 'No response from server'}`);
      } else if (err.request) {
        setLocalError('No response from server');
      } else {
        setLocalError(`${err.message}`);
      }
    } finally {
        setLocalLoading(false);
    }
  };

  return { localAuction, localLoading, localError, fetchLocalWinningAuctions };
};

export default useGetLocalWinningAuction;
